import { IObjektVy } from '../../../../../Types/ObjektVy';
import { objektLänk, standardVy } from '../../../../../Utils/ObjektVyUtils';
import ObjektVySida from '../../../_Common/Components/BusinessCollectionComponents/ObjectVySida';
import { objektVyGrupp } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyGrupp';

const forstaSidan = ObjektVySida('förstaSida', [
  [
    objektVyGrupp(
      'id',
      [
        'BETALNINGSVILLKORKOD',
        'BENAMNING',
        'TEXT',
        'ANTALDAGAR',
        'FRILEVMANAD',
        objektLänk('Kravrutin'),
      ],
      ' '
    ),
  ],
]);

export const standard = standardVy([forstaSidan]);

export const BetalningsvillkorVyer: IObjektVy[] = [standard];
